import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getShootingsByAthleteAndEvent } from "../../db";
import SingleTargetPreview from "./SinlgeTargetPreview";
import { Link} from "react-router-dom";

const RelatedShootings = ({ shooting }) => {
    const { t } = useTranslation();
    const [relatedShootings, setRelatedShootings] = useState([]);

    useEffect(() => {
        const fetchRelatedShootings = async () => {
            if (!shooting || !shooting.event || !shooting.athlete) return;

            const allShootings = await getShootingsByAthleteAndEvent(shooting.athlete, shooting.event);
            const sortedShootings = allShootings.sort((a, b) => {
                const dateA = a.date || a.crdate || 0;
                const dateB = b.date || b.crdate || 0;
                return dateB - dateA; // Newest first
            });

            setRelatedShootings(sortedShootings);
        };

        fetchRelatedShootings();
    }, [shooting]);

    if (!shooting || !shooting.event || !shooting.athlete) {
        return (
            <div className="text-sm text-red-600 mt-6">
                {t("shooting.relatedMissing") || "Event and athlete must be assigned to see related targets."}
            </div>
        );
    }

    if (relatedShootings.length === 0) {
        return (
            <div className="text-sm text-gray-500 mt-6">
                {t("shooting.relatedNone") || "No other targets for this athlete and event."}
            </div>
        );
    }

    return (
        <div className="flex gap-2 overflow-x-auto light-scrollbar landscape:flex-col landscape:overflow-y-auto landscape:grid grid-cols-2">
            {relatedShootings.map((relatedShooting) => (
                <Link to={`/shooting/${relatedShooting.id}`}
                    key={relatedShooting.id}
                >
                    <SingleTargetPreview shooting={relatedShooting} current={(relatedShooting.id === shooting.id)} />
                </Link>
            ))}
        </div>
    );
};

export default RelatedShootings;